import { RestClient } from '../lib/RestClient'

class AutorizacaoService extends RestClient {
  constructor() {
    super('autorizacao')
  }
}

export const Autorizacao = new AutorizacaoService()
